import { ApiCustomer } from '@vend/types'
import { trimContactInfo } from '../../../../react/modals/common/customer-contact-utils'
import { FulfilmentType } from '../../../../../models/fulfilment'
import { CurrentView } from './LineItemFulfillmentContext'

export const trimCustomerInfo = (customer: ApiCustomer) => {
  customer.first_name = customer.first_name?.trim() || ''
  customer.last_name = customer.last_name?.trim() || ''
  trimContactInfo(customer)
}

export const isContactInfoUpdated = (
  customer: ApiCustomer,
  originalCustomer: ApiCustomer
) => {
  return (
    customer.first_name?.trim() !== originalCustomer.first_name?.trim() ||
    customer.last_name?.trim() !== originalCustomer.last_name?.trim() ||
    customer.email?.trim() !== originalCustomer.email?.trim() ||
    customer.mobile?.trim() !== originalCustomer.mobile?.trim() ||
    customer.phone?.trim() !== originalCustomer.phone?.trim() ||
    customer.fax?.trim() !== originalCustomer.fax?.trim()
  )
}

export const isMissingName = (customer: ApiCustomer) => {
  return (
    (!customer.first_name || customer.first_name.trim().length === 0) &&
    (!customer.last_name || customer.last_name.trim().length === 0)
  )
}

export const isMissingContactInfo = (customer: ApiCustomer) => {
  return (
    (!customer.email || customer.email.trim().length === 0) &&
    (!customer.mobile || customer.mobile.trim().length === 0) &&
    (!customer.phone || customer.phone.trim().length === 0) &&
    (!customer.fax || customer.fax.trim().length === 0)
  )
}

/**
 * Handles navigation to the fulfillment method selection view, with special
 * behavior for sales containing service orders.
 *
 * For regular sales: Navigates to the fulfillment method selection view where
 * the user can choose PICKUP, DELIVERY, etc.
 *
 * For service sales: Skips the fulfillment method selection and automatically
 * sets the fulfillment type to PICKUP, then closes the popover. This ensures
 * items appear in the "TO BE ORDERED FOR SERVICE" section, as JAWS (the service
 * order microservice) handles fulfillment externally.
 *
 * @param saleHasServiceOrder - Whether the current sale includes a service order
 * @param onClose - Callback to close the popover
 * @param setCurrentView - Callback to change the current view
 * @param onSelectFulfilmentType - Callback to set the fulfillment type
 * @param fulfilmentOutletId - Outlet the fulfilment should be sourced from
 */
export const handleFulfillmentMethodViewNavigation = (
  saleHasServiceOrder: boolean,
  onClose: () => void,
  setCurrentView: (view: CurrentView) => void,
  onSelectFulfilmentType?: (
    type: FulfilmentType,
    fulfilmentOutletId?: string
  ) => void,
  fulfilmentOutletId?: string
) => {
  if (saleHasServiceOrder) {
    onSelectFulfilmentType?.(FulfilmentType.PICKUP, fulfilmentOutletId)
    onClose()
  } else {
    setCurrentView(CurrentView.FULFILMENT_METHOD)
  }
}
